import React from "react";
import { Spin, Tabs } from "antd";

import IntegrationWooCommerceSettingsForm from "../../Forms/Settings/IntegrationWooCommerce";

const IntegrationSettingsForm = ({ isFetching, setting, handleSubmit }) => {
  const items = [
    {
      key: "woo_commerce",
      label: "WooCommerce",
      children: (
        <IntegrationWooCommerceSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleSubmit} />
      ),
    },
    {
      key: "shopify",
      label: "Shopify",
      children: (
        <IntegrationWooCommerceSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleSubmit} />
      ),
    },
    {
      key: "presta_shop",
      label: "PrestaShop",
      children: (
        <IntegrationWooCommerceSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleSubmit} />
      ),
    },
    {
      key: "open_cart",
      label: "OpenCart",
      children: (
        <IntegrationWooCommerceSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleSubmit} />
      ),
    },
    {
      key: "magento",
      label: "Magento",
      children: (
        <IntegrationWooCommerceSettingsForm isFetching={isFetching} setting={setting} handleSubmit={handleSubmit} />
      ),
    },
  ];

  return (
    <Spin spinning={isFetching}>
      <div className="SettingsForm IntegrationSettings">
        <Tabs defaultActiveKey="woo_commerce" items={items} />
      </div>
    </Spin>
  );
};

export default IntegrationSettingsForm;
